import type { ReactElement } from "react";
import { useSofortPopup } from "@kundeninfo/ui";
import { Chip } from "@kundeninfo/ui/me-design";
import { effortShare, hasEffort, shownEffort } from "./effort.js";
import type { EffortCard } from "./effort.js";
import { EFFORT_TEXT, effortLines } from "./effortTexts.js";

/** Kennzeichen „Plan · Ist“ (A21) an Karte und Liste: rahmenloser Chip, Überschreitung als Fehlerart, Langform für die Vorlesestimme. */
export function EffortMark(p: { card: EffortCard; id?: string; className?: string }): ReactElement | null {
  const s = shownEffort(p.card);
  const shown = hasEffort(s);
  const popup = useSofortPopup<HTMLSpanElement>(shown ? effortLines(s, "popup").join("\n") : "");
  if (!shown) return null;
  const over = (effortShare(s.plan, s.worked)?.overrun ?? 0) > 0;
  const text = EFFORT_TEXT.mark(s.plan, s.worked, s.sum);
  return (
    <span ref={popup} className={p.className === undefined ? "em" : `em ${p.className}`}>
      {over ? <Chip statusArt="fehler"><span aria-hidden="true">{text}</span></Chip>
            : <Chip><span aria-hidden="true">{text}</span></Chip>}
      <span className="bt__unsichtbar" {...(p.id === undefined ? {} : { id: p.id })}>{effortLines(s, "popup").join(". ")}</span>
    </span>
  );
}
